"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Quote;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Quote(_ref) {
  var moduleClass = _ref.moduleClass,
      content = _ref.content,
      author = _ref.author;

  return _react2.default.createElement(
    "div",
    {
      className: "type-quote " + moduleClass
    },
    _react2.default.createElement(
      "div",
      { className: "quote-content" },
      _react2.default.createElement(
        "blockquote",
        null,
        content
      ),
      _react2.default.createElement(
        "p",
        { className: "author" },
        _react2.default.createElement(
          "span",
          null,
          author
        )
      )
    )
  );
} /*
     {
       "type": "quote",
       "content": "...",
       "author": "Former Student Name"
     }
  
     This is for displaying quotes in the body. An example can be found
     on the Educator or Employer template.
  
     Requires both a content and an author attribute, to allow for custom
     styling in the component.
  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Quote/Quote.jsx
// module id = 1256
// module chunks = 0